import { render, staticRenderFns } from "./KonvertRegistration.vue?vue&type=template&id=18a52fd7&"
import script from "./KonvertRegistration.vue?vue&type=script&lang=js&"
export * from "./KonvertRegistration.vue?vue&type=script&lang=js&"
import style0 from "./KonvertRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports